import styled from 'styled-components'

import vector from '../../../../../assets/equipment/vector.svg'

interface FormGridProps {
  cols: number
}

export const StyledFormGroup = styled.div`
  display: flex;
  flex-direction: column;

  label {
    font-size: 14px;
    color: var(
      --light-text-color
    ); /* Assuming you have CSS variables defined */
    margin-bottom: 8px;
    font-weight: bold;
    position: static;
    top: auto;
    left: auto;
    background-color: transparent;
    padding: 0;
    z-index: auto;
  }

  input,
  select {
    padding: 8px 15px;
    border: 1px solid var(--input-border); /* Assuming CSS variable */
    border-radius: 100px;
    font-size: 14px;
    outline: none;
    width: 100%;
    box-sizing: border-box;
    height: 40px;
    line-height: 22px;

    background-color: #ebebeb;
    color: #333;
  }

  select {
    background-image: url(${vector});
    background-size: 18px 9px;
    background-repeat: no-repeat;
    background-position: right 15px center;
    padding-right: 2.5rem;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;

    color: #333;
    option[value=''] {
      color: #c4c4c4;
    }
    option {
      color: #333;
      background-color: white;
    }

    &[multiple] {
      border-radius: 8px;
      height: auto;
      padding: 12px;
      background-image: none;
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      min-height: 100px;
      overflow-y: auto;
    }
  }

  &.flex-grow {
    flex-grow: 1;
  }
`

export const StyledFormGroupWithBorder = styled(StyledFormGroup)`
  padding-top: 1rem;
  background-color: #fff;
  border-radius: 8px;
  input,
  select {
    border: none;
    margin-top: 0;
  }
`

export const FormGrid = styled.div<FormGridProps>`
  display: grid;
  grid-template-columns: repeat(${(props) => props.cols}, 1fr);
  gap: 20px 30px;
  @media (max-width: 992px) {
    grid-template-columns: ${(props) =>
      props.cols === 3 ? 'repeat(2, 1fr)' : 'repeat(2, 1fr)'};
  }
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`

export const MaintenanceServiceWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  width: 100%;
  gap: 1rem;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
  }
`

export const NameGroup = styled(StyledFormGroupWithBorder)`
  flex: 1; /* Occupy remaining space */
`

export const PeriodicidadeGroup = styled(StyledFormGroupWithBorder)`
  flex: 1; /* Occupy remaining space */

  .input-wrapper {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;

    .prefix-text {
      font-size: 14px;
      color: #333;
      white-space: nowrap;
      flex-shrink: 0;
    }

    input,
    select {
      flex: 1;
      min-width: 60px;
      & + select {
        min-width: 80px;
      }
    }
  }
`

export const DeleteButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  margin-top: 43px; /* Align with input fields */

  img {
    width: 20px;
    height: 20px;
    object-fit: contain;
  }
`

export const ActionButtons = styled.div`
  display: flex;
  justify-content: flex-end;
`

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

export const CancelButton = styled.button`
  background-color: #ffffff;
  color: #0090d3;
  border: 1px solid #0090d3;
  padding: 8px 18px;
  border-radius: 100px;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;

  &:hover {
    background-color: #f0f8ff;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`

export const SaveButton = styled.button`
  background-color: #0090d3;
  color: white;
  border: none;
  padding: 8px 18px;
  border-radius: 100px;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
  height: 38px;
  display: flex;
  align-items: center;
  gap: 8px;
  box-sizing: border-box;

  &:hover {
    background-color: #007bb5;
  }

  &:disabled {
    background-color: #cccccc;
    cursor: not-allowed;
  }
`

export const AddMaintenanceButton = styled.button`
  background-color: transparent;
  color: #0090d3;
  border: none;
  padding: 12px 24px;
  border-radius: 100px;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: fit-content;
  margin: 0 auto;
  padding-top: 2.5rem;

  img {
    width: 12px;
    height: 12px;
  }
`

export const Container = styled.div`
  position: absolute;
  top: 50vh;
  left: 50vw;
  transform: translate(-50%, -50%);
  background-color: #fff;
  border-radius: 1vw;
  z-index: 1;
  display: flex;
  flex-direction: column;
  max-height: 90vh;
  overflow-y: hidden;
  width: 60vw;
  color: #303030;

  @media (max-width: 1280px) {
    width: 70vw;
  }

  @media (max-height: 768px) {
    max-height: 95vh;
    top: 50%;
  }

  @media (max-width: 768px) {
    width: 90vw;
  }
`

export const HeaderDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: calc(100% - 2.4vw);
  margin-top: 2.8vh;
  margin-left: 1.2vw;
  margin-right: 1.2vw;
  box-sizing: border-box;
  flex-shrink: 0;

  @media (max-height: 768px) {
    margin-top: 1.5vh;
  }
`

export const HeaderText = styled.h2`
  font-size: 1.4vw;
  font-weight: 700;
  margin: 0;
  color: #303030;
`

export const CloseDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  cursor: pointer;
  width: 36px;
  height: 36px;
  background-color: #eaeaea;
  color: #303030;
  flex-shrink: 0;

  &:hover {
    background-color: #ddd;
  }
`

export const ContentContainer = styled.div`
  padding: 1.2vw 1.2vw 2.5vh;
  display: flex;
  flex-direction: column;
  gap: 2vh;
  color: #303030;
  overflow-y: auto;
  flex: 1;
  min-height: 0;

  @media (max-height: 768px) {
    padding: 1vh 1.2vw 2vh;
    gap: 1.5vh;
  }
`

export const Section = styled.div`
  background-color: #fff;
  padding: 1vh 0;
  display: flex;
  flex-direction: column;
  color: #303030;

  &:not(:first-child) {
    border-top: 1px solid #e0e0e0;
    padding-top: 3vh;
  }
`

export const SectionHeader = styled.h3`
  font-size: 1.25vw;
  font-weight: 700;
  color: #303030;
  margin-bottom: 1vh;
`

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 2.5vh 1.2vw;
  border-top: 1px solid #e0e0e0;
  color: #303030;
  gap: 15px;
  flex-shrink: 0;

  @media (max-height: 768px) {
    padding: 1.5vh 1.2vw;
  }
`
